import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import cls from "classnames"
import Container from "@/components/container"
import * as styles from "./index.module.scss"
import LinkModule from "@/components/link-module"

const FeaturedPartner: React.FC<{
  title: string
  description?: string
  moreLinkNode?: React.ReactNode
  clickableLogo: boolean
}> = ({
  title = "精选客户案例",
  description = undefined,
  moreLinkNode = <LinkModule to={"/case"}>查看更多客户案例</LinkModule>,
  clickableLogo = true,
}) => {
  const cases = [
    {
      node: {
        id: "1",
        customerCase: {
          id: "1",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_13_2x_75417d8ba5.jpg",
            },
            alt: "中国平安",
          },
        },
      },
    },
    {
      node: {
        id: "2",
        customerCase: {
          id: "2",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_18_2x_a401f6949f.jpg",
            },
            alt: "中国银行",
          },
        },
      },
    },
    {
      node: {
        id: "3",
        customerCase: {
          id: "3",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_19_2x_b079dc46af.jpg",
            },
            alt: "光大银行",
          },
        },
      },
    },
    {
      node: {
        id: "4",
        customerCase: {
          id: "4",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_1_2x_9089500e53.jpg",
            },
            alt: "北京银行",
          },
        },
      },
    },
    {
      node: {
        id: "5",
        customerCase: {
          id: "5",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_5_2x_4db1e3b6ba.jpg",
            },
            alt: "微众银行",
          },
        },
      },
    },
    {
      node: {
        id: "6",
        customerCase: {
          id: "6",
          logoWallLogo: {
            media: {
              url: "https://img1.pingcap.com/prod/logo_1_a8a138337f.png",
            },
            alt: "美团",
          },
        },
      },
    },
    {
      node: {
        id: "7",
        customerCase: {
          id: "7",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_10_2x_6e87324d65.jpg",
            },
            alt: "58 集团",
          },
        },
      },
    },
    {
      node: {
        id: "8",
        customerCase: {
          id: "8",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_3_2x_76d7168e74.jpg",
            },
            alt: "360",
          },
        },
      },
    },
    {
      node: {
        id: "9",
        customerCase: {
          id: "9",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_12_2x_c7e75aae0d.jpg",
            },
            alt: "网易互娱",
          },
        },
      },
    },
    {
      node: {
        id: "10",
        customerCase: {
          id: "10",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_14_2x_6cec41c7bf.jpg",
            },
            alt: "小红书",
          },
        },
      },
    },
    {
      node: {
        id: "11",
        customerCase: {
          id: "11",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_bilibili_3c57a68bba.jpg",
            },
            alt: "bilibili",
          },
        },
      },
    },
    {
      node: {
        id: "12",
        customerCase: {
          id: "12",
          logoWallLogo: {
            media: {
              url:
                "https://img1.pingcap.com/prod/logo_case_15_2x_7e77aa8617.jpg",
            },
            alt: "汽车之家",
          },
        },
      },
    },
  ]

  return (
    <Container className={cls(styles.container)}>
      <h1 className={cls(styles.h1, styles.title)}>{title}</h1>
      {description && (
        <h5 className={cls(styles.h5, styles.description)}>{description}</h5>
      )}
      <div className="columns is-mobile is-variable is-2-mobile is-2-tablet is-4-desktop is-flex-wrap-wrap is-align-items-center">
        {cases.map(({ node }: { node: StrapiCaseForLogoWall }) => (
          <div
            className="column is-2-desktop is-6-mobile is-6-tablet logo-wall-image"
            key={node.customerCase.id}
          >
            {clickableLogo ? (
              <Link
                to={`/case/${
                  node.customerCase.customUrl ??
                  `Customer-cases_${node.customerCase.id}`
                }`}
              >
                <img
                  src={node.customerCase.logoWallLogo.media.url}
                  alt={node.customerCase.logoWallLogo.alt}
                />
              </Link>
            ) : (
              <img
                src={node.customerCase.logoWallLogo.media.url}
                alt={node.customerCase.logoWallLogo.alt}
              />
            )}
          </div>
        ))}
      </div>
      <footer className={styles.more}>{moreLinkNode}</footer>
    </Container>
  )
}

export default FeaturedPartner
